/* MK Custom - Cart Financing Panels */

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-cart-finance-toggle]');

  if (!toggle) return;

  const finance = toggle.closest('[data-mkcustom-cart-financing]');

  if (!finance) return;

  const target = toggle.getAttribute('data-cart-finance-toggle');

  const targetPanel = finance.querySelector(
    '[data-cart-finance-panel="' + target + '"]'
  );

  if (!targetPanel) return;

  const isAlreadyOpen = !targetPanel.hidden;

  /* MK Custom - Close existing provider panels */
  finance.querySelectorAll('[data-cart-finance-panel]').forEach(function (panel) {
    panel.hidden = true;
  });

  finance.querySelectorAll('[data-cart-finance-toggle]').forEach(function (button) {
    button.classList.remove('is-active');
    button.setAttribute('aria-expanded', 'false');
  });

  /* MK Custom - Toggle selected provider */
  if (!isAlreadyOpen) {
    targetPanel.hidden = false;

    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
  }
});

/* MK Custom - Cart Financing Provider Modals */

document.addEventListener('click', function (event) {

  /* MK Custom - Affirm Details */
  if (event.target.closest('[data-cart-affirm-details]')) {
    let affirmLink = document.querySelector(
      '#mkcustom-cart-affirm-message .affirm-modal-trigger'
    );

    if (!affirmLink) {
      affirmLink = document.querySelector('.affirm-modal-trigger');
    }

    if (affirmLink) {
      affirmLink.click();
    }
  }


  /* MK Custom - Shop Pay Checkout Action */

    if (event.target.closest('[data-cart-shop-pay-checkout]')) {
    const shopPayButton =
        document.querySelector('.dynamic-cart-btns shop-pay-wallet-button') ||
        document.querySelector('.dynamic-cart-btns [data-testid*="ShopPay"]') ||
        document.querySelector('.dynamic-cart-btns button');

    if (shopPayButton) {
        shopPayButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
        });

        shopPayButton.focus?.();
    }
  }


  /* MK Custom - Synchrony Details */
  if (event.target.closest('[data-cart-synchrony-details]')) {
    if (
      window.syfMPP &&
      typeof window.syfMPP.openMPPOfferModal === 'function'
    ) {
      window.syfMPP.openMPPOfferModal({
        partnerId: 'PI20029112',
        amount:
          document
            .querySelector('[data-mkcustom-cart-financing]')
            ?.getAttribute('data-cart-finance-amount') || '0',
        flowType: 'CART',
        partnerProfileCode: 'PS_SMB',
        merchantRefererUrl: 'https://focuscamera.com/',
        siteCode: 'SesPdpSh01',
        clientName: 'Synchrony'
      });
    }
  }

});